<template>
  <div class="home">
    <v-container fluid fill-height>
      <login-register />
    </v-container>
  </div>
</template>

<script>
import LoginRegister from "@/components/Frontend/LoginRegister.vue";
export default {
  name: "Login",
  components: {
    LoginRegister,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.home {
  height: 100vh;
  // background-image: url("../../assets/img/octalis_hd_bg.png");
  background: linear-gradient(0deg, var(--v-primary-base) 0%, #017148 100%);
  // background-color: #017148;
  background-size: cover;
  overflow: hidden;
}
</style>
